import {
  getDailyChartReports,
  getDelayChartReports,
  getOrders,
  getProductsById,
  getReports
} from './thunk';

export const builderGetVendorReports = (builder: any) => {
  builder.addCase(getReports.fulfilled, (state: any, action: any) => {
    state.isloadingReports = false;
    state.getReportsError = '';
    state.reports = action.payload;
  });
  builder.addCase(getReports.pending, (state: any) => {
    state.isloadingReports = true;
    state.getReportsError = '';
  });
  builder.addCase(getReports.rejected, (state: any, action: any) => {
    state.isloadingReports = true;
    state.getReportsError = action.payload.message;
  });
};

export const builderGetDailyChartReport = (builder: any) => {
  builder.addCase(getDailyChartReports.fulfilled, (state: any, action: any) => {
    state.isloadingDailyChartReports = false;
    state.getDailyChartReportsError = '';
    state.chartReports = action.payload;
  });
  builder.addCase(getDailyChartReports.pending, (state: any) => {
    state.isloadingDailyChartReports = true;
    state.getDailyChartReportsError = '';
  });
  builder.addCase(getDailyChartReports.rejected, (state: any, action: any) => {
    state.isloadingDailyChartReports = true;
    state.getDailyChartReportsError = action.payload.message;
  });
};

export const builderGetDelayChartReport = (builder: any) => {
  builder.addCase(getDelayChartReports.fulfilled, (state: any, action: any) => {
    state.isloadingDelayChartReports = false;
    state.getDelayChartReportsError = '';
    state.chartDelayReports = action.payload;
  });
  builder.addCase(getDelayChartReports.pending, (state: any) => {
    state.isloadingDelayChartReports = true;
    state.getDelayChartReportsError = '';
  });
  builder.addCase(getDelayChartReports.rejected, (state: any, action: any) => {
    state.isloadingDelayChartReports = true;
    state.getDelayChartReportsError = action.payload.message;
  });
};

export const builderGetOrders = (builder: any) => {
  builder.addCase(getOrders.fulfilled, (state: any, action: any) => {
    state.getOrdersLoading = false;
    state.getOrdersError = '';
    state.orders = action?.payload?.orders;
    state.pagination = action?.payload?.pagination;
  });
  builder.addCase(getOrders.pending, (state: any) => {
    state.getOrdersLoading = true;
    state.getOrdersError = '';
  });
  builder.addCase(getOrders.rejected, (state: any, action: any) => {
    state.getOrdersLoading = true;
    state.getOrdersError = action.payload.message;
  });
};

export const builderGetProducts = (builder: any) => {
  builder.addCase(getProductsById.fulfilled, (state: any, action: any) => {
    state.getOrdersProductsLoading = false;
    state.getOrdersProductsError = '';
    state.ordersProducts = action.payload;
  });
  builder.addCase(getProductsById.pending, (state: any) => {
    state.getOrdersProductsLoading = true;
    state.getOrdersProductsError = '';
  });
  builder.addCase(getProductsById.rejected, (state: any, action: any) => {
    state.getOrdersProductsLoading = true;
    state.getOrdersProductsError = action.payload.message;
  });
};
